import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { impParnellCommon } from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
    standalone: false,
    selector: 'forgot-password',
    templateUrl: '../app/pages/forgot-password/forgot-password.view.html',
    styleUrls: ['../app/pages/forgot-password/forgot-password.style.css']
    })
export class ForgotPassword implements OnInit {

    @ViewChild('formForgotPassword') formForgotPassword: NgForm;

    private performanceContext: PerformanceContext | null = null;

    inputs = { email: '' };
    invalidOrExpiredResetRequest: boolean = false;
    submitting: boolean = false;
    accountDoesntExist: boolean = false;

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService){ }

    ngOnInit(): void {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming('Page:ForgotPassword:Render');
            this.perfMetricSvc.startTiming('Page:ForgotPassword:Build');
            this.perfMetricSvc.endTiming("page", 'Page:ForgotPassword:Build', this.performanceContext);
            this.perfMetricSvc.markPageReady('Page:ForgotPassword:Render', this.performanceContext);
        });
    }

    // restores the initial state of the page
    reset(): void {
        this.inputs = { email: '' };
        this.invalidOrExpiredResetRequest = false;
        this.submitting = false;
        this.accountDoesntExist = false;
    }

    // the user is editing the email, so the previous submit's 'account doesn't exist' message no longer applies
    onEmailChange(): void {
        this.accountDoesntExist = false;
    }

    // true when an email has been entered but doesn't look like an email address
    emailFormatIsInvalid(): boolean {
        return !!this.inputs.email && !impParnellCommon.validation.isValidEmail(this.inputs.email);
    }

    cancel(): void {
        this.MSF.loadPage('Login');
    }

    submit(): void {
        this.invalidOrExpiredResetRequest = false;
        this.accountDoesntExist = false;

        if (!this.formForgotPassword.valid || this.emailFormatIsInvalid()) {
            // show the validation messages for any invalid controls
            this.formForgotPassword.form.markAllAsTouched();
            return;
        }

        this.submitting = true;
        this.api.createPasswordResetRecord(this.inputs.email, (err:any, result:any) => {
            this.submitting = false;

            if (err) {
                this.accountDoesntExist = true;
                return this.log.error(err);
            }

            this.log.info(result);
            this.MSF.notify.success('Check your email for the link to reset your password.');
            this.MSF.loadPage('Login');
        });
    }
}
